import React, { useCallback, useContext, useEffect, useState } from "react";
import FilterCall from "../components/home/FilterCall";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { baseURL, domain } from "../utils/axios";
import { StoreContext } from "../Context/StoreContext";
import * as io from "socket.io-client";
import { useRef } from "react";
import TalkingUsersModal from "../VibehutUI/TalkingUsersModal";
import PopularEventCard from "../VibehutUI/Card/PopularEventCard";
import WhatsHappening from "../VibehutUI/WhatsHappening";
import PopularRooms from "../components/rooms/PopularRooms";
import "react-multi-carousel/lib/styles.css";
import HomeEventsCalender from "../components/events/HomeEventsCalender";
import HomeNewEvents from "../components/events/HomeNewEvents";
import HomePopularEvents from "../components/events/HomePopularEvents";
import HomeLiveEvent from "../components/events/HomeLiveEvent";
import HomeNewUpcomingEvent from "../components/events/HomeNewUpcomingEvent";
import CreatedLinkModal from "../components/CreatedLinkModal";
import HomeMyEvent from "../components/events/HomeMyEvent";
import MyRecentRooms from "../components/rooms/MyRecentRooms";
import UserNotificationAction from "../components/home/UserNotificationAction";
import LiveConversations from "../components/home/LiveConversations";
import LiveCalls from "../components/home/LiveCalls";
import HomeHeader from "../components/home/HomeHeader";
import NewsletterCard from "../VibehutUI/Card/NewsletterCard";
import HomeRequestEvents from "../components/home/HomeRequestEvents";
import PushNotificationBanner from "../components/home/PushNotificationBanner";
import { HomePromotion } from "../components/home/HomePromotion";
import useQuery from "../hooks/useQuery";
import globals from "../globals";
import RecordedCallModal from "../components/call/RecordedCallModal";
import HomeAutoOrganizedEvents from "../components/home/HomeAutoOrganizedEvents";
import CurrentlyHappening from "../components/home/CurrentlyHappening";
import { SideAd } from "../components/Ads";
import { getMyRecentRooms } from "../actions/roomAction";

function HomePage() {
  const socketRef = useRef();
  const containerRef = useRef();
  const history = useHistory();
  const query = useQuery();
  const [isOpen, setIsOpen] = useState(false);
  const { state, dispatch } = useContext(StoreContext);
  const {
    auth,
    room: { generalRoom },
  } = state;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [calls, setCalls] = useState([]);
  const [liveUsersCount, setLiveUsersCount] = useState(0);
  const [lobbyUsers, setLobbyUsers] = useState([]);
  const [sliderWidth, setSliderWidth] = useState(0);
  const [roomUUID, setRoomUUID] = useState(undefined);
  const callId = query.get("callId") || null;

  const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
  const goToCallPage = (matchPoints) => {
    history.push({
      pathname: `/call`,
      search: `${
        typeof matchPoints === "number" ? `?match_points=${matchPoints}` : ""
      }`,
      state: { previousPath: history.location.pathname },
    });
  };

  useEffect(() => {
    if (auth?.user) {
      getMyRecentRooms(auth.user?.token, dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    window.addEventListener("resize", () => {
      setScreenWidth(window.innerWidth);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateSocketData = ({ queue_room }) => {
    setLiveUsersCount(queue_room.liveUsersCount);

    if (queue_room.lobby_users) {
      setLobbyUsers(queue_room.lobby_users);
    }
    setCalls(Object.values(queue_room.calls || {}));
  };

  const generalRoomId = generalRoom?._id;

  React.useEffect(() => {
    const roomId = generalRoomId;
    if (roomId !== undefined) {
      socketRef.current = io.connect(`${baseURL}/room`);
      socketRef.current.on("connect", () => {
        socketRef.current.emit(
          "join-room",
          {
            roomId,
          },
          updateSocketData,
        );
      });
      socketRef.current.on("update_call", updateSocketData);

      return () => {
        if (socketRef.current) {
          socketRef.current.disconnect();
          socketRef.current = undefined;
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generalRoomId]);

  React.useEffect(() => {
    if (containerRef.current) {
      let clientWidth = containerRef.current.clientWidth;
      if (screenWidth > 1279) {
        clientWidth = screenWidth - 648;
        if (screenWidth > 1920) {
          clientWidth = 1920 - 648;
        }
      }
      setSliderWidth(clientWidth);
    }
  }, [screenWidth]);

  useEffect(() => {
    if (callId) {
      showRecordedCallPopup();
    }
  }, [callId]);

  const showRecordedCallPopup = useCallback(() => {
    globals.showModal(
      "Call Recorded",
      <>
        <RecordedCallModal />
      </>,
    );
  }, []);
  return (
    <div className="font-ubuntu" ref={containerRef}>
      <Helmet>
        <title>Vibehut</title>
        <meta
          name="description"
          content="Start meeting new and interesting people to build your Vibehut network."
        />

        {/* <!-- Facebook Meta Tags -- > */}
        <meta property="og:url" content="https://vibehut.io/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Vibehut" />
        <meta
          property="og:description"
          content="Start meeting new and interesting people to build your Vibehut network."
        />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/banner.png`}
        />

        {/* <!-- Twitter Meta Tags -- > */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content={domain} />
        <meta property="twitter:url" content="https://vibehut.io/" />
        <meta name="twitter:title" content="Vibehut" />
        <meta
          name="twitter:description"
          content="Start meeting new and interesting people to build your Vibehut network."
        />
        <meta
          name="twitter:image"
          content={`${process.env.PUBLIC_URL}/banner.png`}
        />
      </Helmet>

      <>
        <div className="block">
          <HomeHeader />
        </div>

        <div className="block">
          <HomePromotion />
        </div>

        <div className="block">
          <CurrentlyHappening
            sliderWidth={sliderWidth < 900 ? sliderWidth - 10 : sliderWidth}
          />
        </div>
        <div className="block">
          <LiveCalls
            sliderWidth={sliderWidth < 900 ? sliderWidth - 10 : sliderWidth}
          />
        </div>
        <div className="block">
          <LiveConversations
            sliderWidth={sliderWidth < 900 ? sliderWidth - 10 : sliderWidth}
          />
        </div>

        <div className="block">
          <HomeRequestEvents
            sliderWidth={sliderWidth < 900 ? sliderWidth - 10 : sliderWidth}
          />
        </div>
        <div className="block">
          <HomeAutoOrganizedEvents
            sliderWidth={sliderWidth < 900 ? sliderWidth - 10 : sliderWidth}
          />
        </div>
        <div className="block pt-6">
          <PushNotificationBanner />
        </div>
        <div className="block">
          <MyRecentRooms />
        </div>
        <div className="block">
          <HomeMyEvent />
        </div>
        <div className="md:py-5 py-4">
          <div className="block w-full">
            <p className="select-none font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite px-2">
              Discover
            </p>
          </div>
          <div className="flex md:flex-row flex-col  md:pt-6 pt-4  md:space-x-5 space-x-0 space-y-12 md:space-y-0">
            <div className="block md:w-1/2 w-full">
              <PopularEventCard />
            </div>

            <div className="block md:w-1/2 w-full pr-2">
              <WhatsHappening />
            </div>
          </div>
        </div>
        <div className="block">
          <SideAd dataAdSlot="2661729841" />
        </div>
        <div className="block">
          <UserNotificationAction />
        </div>
        <div className="block">
          <PopularRooms
            sliderWidth={sliderWidth < 900 ? sliderWidth - 10 : sliderWidth}
          />
        </div>

        <div className="block">
          <HomeLiveEvent />
        </div>

        <div className="block">
          <HomeNewUpcomingEvent />
        </div>

        <div className="block w-full">
          <HomeEventsCalender />
        </div>

        <div className="block w-full md:hidden pb-8">
          <NewsletterCard />
        </div>

        <div className={"block"}>
          <HomePopularEvents />
        </div>
        <div className={"block"}>
          <HomeNewEvents />
        </div>
        {/* <div className="block">
            <HomeUpcomingEvents sliderWidth={sliderWidth - 16} />
          </div> */}

        {auth?.user ? (
          <FilterCall
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            goToCallPage={goToCallPage}
          />
        ) : undefined}
        <TalkingUsersModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          usersCount={liveUsersCount}
          talkingUsers={calls}
          lobby_users={lobbyUsers}
        />

        {auth?.user && roomUUID ? (
          <CreatedLinkModal
            isOpen={!!roomUUID}
            setIsOpen={(flag) => !flag && setRoomUUID(undefined)}
            roomCode={roomUUID}
          />
        ) : undefined}
      </>
    </div>
  );
}

export default HomePage;
